module.exports = __webpack_public_path__ + "static/media/BY.ad33ee06.svg";